/* stylelint-disable value-no-vendor-prefix */

import { css } from '@sitebase/emotion';
import { rgba } from 'polished';
import { colorMonochromeWhite, colorPrimary500, colorPrimary30, rawButton, fontDefaults } from '../settings';

var arrowWidth = '38px';

export var arrowActive = /*#__PURE__*/css('cursor:pointer;');
export var arrow = /*#__PURE__*/css(rawButton, ';', fontDefaults, ';align-items:center;display:flex;display:-webkit-box;height:100%;justify-content:center;width:', arrowWidth, ';flex-shrink:0;');
export var arrowLight = /*#__PURE__*/css('color:', rgba(colorPrimary500, 0.2), ';&.', arrowActive, '{color:', colorPrimary500, ';&:hover,&:active{background-color:', rgba(colorPrimary30, 0.6), ';}}');
export var arrowDark = /*#__PURE__*/css('color:', rgba(colorMonochromeWhite, 0.2), ';&.', arrowActive, '{color:', colorMonochromeWhite, ';&:hover,&:active{background-color:', rgba(colorMonochromeWhite, 0.1), ';}}');